import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Grading } from "../Icon";
import makeStyles from "@mui/styles/makeStyles";
import { useEffect, useState } from "react";
import { getGrades } from "../../../../Common/gradeWeights";

const useStyles = makeStyles((theme) => ({
  mainTypography: {
    fontSize: 17,
    fontWeight: 600,
    color: "#4B4B4B",
  },
  secondTypography: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.gif.orange.color,
  },
  typography: {
    fontSize: 14,
    fontWeight: 400,
    color: "#4B4B4B",
  },
  icon: {
    marginTop: 10,
  },
  totalRow: {
    backgroundColor: theme.palette.gif.orange.light,
    fontWeight: 600,
  },
  totalTypography: {
    fontWeight: 600,
    fontSize: 14,
  },
}));

const GradingSummary = (props) => {
  const classes = useStyles();
  const { proposalReferee } = props;
  const tableHeaders = [
    { label: "Evaluation item", size: "50%" },
    { label: "Weight (%)", size: "15%" },
    { label: "Grade (0-100)", size: "15%" },
    { label: "Weighted grade", size: "15%" },
  ];
  const [grades, setGrades] = useState([]);
  const [totalGrades, setTotalGrades] = useState([]);

  const buildGardes = (proposalReferee) => {
    const originalityGarde = proposalReferee.originalityInnovation;
    const adequacyGarde = proposalReferee.adequacyOfMethods;
    const suitabillyGarde =
      proposalReferee.suitabilityOfInvestigatorsScientific;
    const cooperationGarde = proposalReferee.modeOfCooperationBetweenTheTeams;
    const grades = getGrades(
      originalityGarde,
      adequacyGarde,
      suitabillyGarde,
      cooperationGarde
    );
    setGrades(grades);
  };

  useEffect(() => {
    let totalGrade = 0;
    let totalWeight = 0;
    grades.forEach((grade) => {
      totalGrade += grade.weightedGrade;
      totalWeight += grade.weight;
    });
    setTotalGrades({ grade: totalGrade, weight: totalWeight });
  }, [grades]);

  useEffect(() => {
    if (proposalReferee === null || proposalReferee === undefined) return;
    buildGardes(proposalReferee);
    // setDetailedEvaluation(proposalReferee.detailedEvaluation);
  }, [proposalReferee]);

  return (
    <Box margin={3}>
      <Grid container spacing={1}>
        <Grid item>
          <Grading className={classes.icon} />
        </Grid>
        <Grid item>
          <Box textAlign="left" marginLeft={2}>
            <Typography variant="subtitle2" className={classes.mainTypography}>
              Grading
            </Typography>
            <Typography
              variant="subtitle2"
              className={classes.secondTypography}
            >
              Not sent to the applicant
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Table size="small">
            <TableHead>
              <TableRow>
                {tableHeaders.map((header) => (
                  <TableCell
                    className={classes.tableCell}
                    key={header.label}
                    align="left"
                    style={{ width: header.size }}
                  >
                    {header.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {grades.map((grade) => (
                <TableRow key={grade.name}>
                  <TableCell>{grade.name}</TableCell>
                  <TableCell>{grade.weight}%</TableCell>
                  <TableCell>{grade.grade}</TableCell>
                  <TableCell>{grade.weightedGrade}</TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter className={classes.totalRow}>
              <TableRow>
                <TableCell>
                  <Typography className={classes.totalTypography}>
                    Total
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography className={classes.totalTypography}>
                    {totalGrades.weight}%
                  </Typography>
                </TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <Typography className={classes.totalTypography}>
                    {totalGrades.grade}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </Grid>
      </Grid>
    </Box>
  );
};

export default GradingSummary;
